import { queryOptions, useMutation } from "@tanstack/react-query"

import { apiKey } from "@/lib/api/changes"
import { apiFetch } from "@/lib/api/client"
import type { ApiResource } from "@/lib/api/types"
import type {
  Onboarding,
  OnboardingSetup,
  SetUpOnboardingInput,
} from "@/types/onboarding"

export const onboardingQueries = {
  firm: (firmId: string) =>
    queryOptions({
      queryKey: apiKey(`/firms/${firmId}/onboarding`),
      queryFn: async ({ signal }) => {
        const { data } = await apiFetch<ApiResource<Onboarding>>(
          `/firms/${firmId}/onboarding`,
          { signal }
        )

        return data
      },
    }),

  setup: (firmId: string) =>
    queryOptions({
      queryKey: apiKey(`/firms/${firmId}/onboarding/create`),
      queryFn: async ({ signal }) => {
        const { data } = await apiFetch<ApiResource<OnboardingSetup>>(
          `/firms/${firmId}/onboarding/create`,
          { signal }
        )

        return data
      },
    }),
}

export function useSetUpOnboarding(firmId: string) {
  return useMutation({
    mutationFn: async (input: SetUpOnboardingInput) => {
      const { data } = await apiFetch<ApiResource<Onboarding>>(
        `/firms/${firmId}/onboarding`,
        { method: "POST", body: input }
      )

      return data
    },
  })
}
